export default "__VITE_PUBLIC_ASSET__08d0712a__"